<template>
  <utd-content-searchbar :ai-mode-click-event-prefix="aiModeClickEventPrefix" />
</template>

<script>
import UtdContentSearchbar from './SearchBar.vue';

export default {
    components: {
        UtdContentSearchbar
    },
    props: {
        aiModeClickEventPrefix: String
    }
};
</script>